import StatusChip from './StatusChip/StatusChip'
import useClientTabStatusChips from './useClientTabStatusChips'
import { StatusChipsRow } from './styled-components'

interface ClientTabStatusChipsProps {
  hidden: boolean
}

const ClientTabStatusChips = ({ hidden }: ClientTabStatusChipsProps) => {
  const { hidden: contactNotLoaded, chips } = useClientTabStatusChips()

  if (hidden || contactNotLoaded) return null

  return (
    <StatusChipsRow>
      {chips.map(chip => (
        <StatusChip key={chip.key} text={chip.text} tone={chip.tone} onClick={chip.onClick} />
      ))}
    </StatusChipsRow>
  )
}

export default ClientTabStatusChips
